import { Component } from '@angular/core';
import { HeaderComponent } from "../header/header.component";
import { SidebarComponent } from "../sidebar/sidebar.component";
import { RouterModule } from '@angular/router';
import { MemberInsurerServiceService } from '@app/modules/lps-member-login/services/member-insurer-service.service';
import { Roles } from '@app/modules/lps-member-login/models/commonmodel';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [HeaderComponent, SidebarComponent, RouterModule],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'] // ✅ FIXED
})
export class DashboardComponent {

  constructor(private memberService : MemberInsurerServiceService){

  }

  enumRole = Roles;
  
  isSidebarCollapsed = false;
  role = this.memberService.getLoginUserRole();
  roleAccess = this.memberService.getUserAccess();

  onSidebarToggle(collapsed: boolean) {
    this.isSidebarCollapsed = collapsed;
  }
}
